/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EditingIcon = createIcon("EditingIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#665AF4';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("rect", {
    width: "16",
    height: "16",
    rx: "2",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.246 3.754a1.516 1.516 0 00-2.154.015L4.05 9.81l-.737 2.877 2.877-.737 6.041-6.042a1.516 1.516 0 00.015-2.154Z",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.92 4.942 2.138 2.139",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});